/** Ticket fields resolved directly in PaymentProofService.resolveMappedValue. */
export const PAYMENT_PROOF_CORE_MAPPING_FIELDS = [
  { fieldKey: "accountNo", displayLabel: "Account No" },
  { fieldKey: "targetOutstanding", displayLabel: "Outstanding" },
  { fieldKey: "recoveryAmount", displayLabel: "Recovery Amount" },
];

export const buildPaymentProofMappingColumnOptions = (columnConfig = [], extraFieldKeys = []) => {
  const seen = new Set();
  const options = [];

  const addOption = (fieldKey, displayLabel) => {
    if (!fieldKey || seen.has(fieldKey)) {
      return;
    }
    seen.add(fieldKey);
    options.push({
      fieldKey,
      displayLabel: displayLabel || fieldKey,
    });
  };

  PAYMENT_PROOF_CORE_MAPPING_FIELDS.forEach(({ fieldKey, displayLabel }) => {
    addOption(fieldKey, displayLabel);
  });

  (Array.isArray(columnConfig) ? columnConfig : []).forEach((column) => {
    addOption(column.fieldKey, column.displayLabel);
  });

  (Array.isArray(extraFieldKeys) ? extraFieldKeys : []).forEach((fieldKey) => {
    addOption(fieldKey, fieldKey);
  });

  return options.sort((left, right) =>
    left.displayLabel.localeCompare(right.displayLabel, undefined, { sensitivity: "base" })
  );
};

export const PAYMENT_PROOF_FIELD_KEYS = [
  "certificateDate",
  "customerName",
  "idNumber",
  "accountNumber",
  "dueAmount",
  "amountCollected",
  "adjustment",
  "discount",
  "balance",
];

export const DEFAULT_PAYMENT_PROOF_PRIMARY_COLOR = "#E87722";

export const normalizePaymentProofPrimaryColor = (
  value,
  fallback = DEFAULT_PAYMENT_PROOF_PRIMARY_COLOR
) => {
  if (value == null || value === "") {
    return fallback;
  }
  const trimmed = String(value).trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) {
    return trimmed.toUpperCase();
  }
  if (/^#[0-9A-Fa-f]{3}$/.test(trimmed)) {
    return `#${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}${trimmed[3]}${trimmed[3]}`.toUpperCase();
  }
  if (fallback == null) {
    return null;
  }
  return fallback;
};

export const isValidPaymentProofPrimaryColor = (value) => {
  const normalized = normalizePaymentProofPrimaryColor(value, null);
  return normalized != null && /^#[0-9A-Fa-f]{6}$/.test(normalized);
};

export const applyPaymentProofPlaceholders = (templateText, fieldData = {}, template = {}) => {
  if (!templateText) return "";
  let resolved = String(templateText);
  PAYMENT_PROOF_FIELD_KEYS.forEach((key) => {
    resolved = resolved.replaceAll(`{${key}}`, fieldData[key] ?? "");
  });
  if (template?.telecomPartnerName) {
    resolved = resolved.replaceAll("{telecomPartner}", template.telecomPartnerName);
  }
  return resolved.trim();
};

export const buildWhatsAppMessage = (template, fieldData, overrideMessage) => {
  const source = overrideMessage || template?.whatsappMessageTemplate || "";
  return applyPaymentProofPlaceholders(source, fieldData, template);
};

export const resolveBodyText = (text, fieldData = {}, template = {}) =>
  applyPaymentProofPlaceholders(text, fieldData, template);

export const formatPaymentProofDateTime = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toLocaleString();
};
